import { createContext } from 'react';
import { I18nContextLoaderType } from 'i18n/types';

const I18nContextLoader = createContext<I18nContextLoaderType>(() => Promise.resolve());

export default I18nContextLoader;
